export const BASE_URL = "https://api.mysocialbizcard.com/";
//export const BASE_URL = "http://localhost:3006/";
export const LOGIN = `${BASE_URL}google-login`;
export const PROFILE = `${BASE_URL}profile`;
export const UPLOAD_IMAGE = `${BASE_URL}extract-details`;
export const UPLOAD_MULTI_IMAGE = `${BASE_URL}extract-details-multi`;
export const CONTACT_LIST = `${BASE_URL}contact/list`;
export const ADD_CONTACT = `${BASE_URL}contact`;
export const EDIT_CONTACT = (contactId) => `${BASE_URL}contact/${contactId}`;
export const GET_CONTACT_BY_ID = (contactId) =>
  `${BASE_URL}contact/${contactId}`;
export const DELETE_CONTACT_LIST = (contactId) =>
  `${BASE_URL}contact/${contactId}`;

// Groups endpoints
export const GROUPS_LIST = `${BASE_URL}groups`;
export const CREATE_GROUP = `${BASE_URL}groups`;
export const EDIT_GROUP = (groupId) => `${BASE_URL}groups/${groupId}`;
export const DELETE_GROUP = (groupId) => `${BASE_URL}groups/${groupId}`;

// Tags endpoints
export const TAGS_LIST = `${BASE_URL}tags`;
export const CREATE_TAG = `${BASE_URL}tags`;
export const EDIT_TAG = (tagId) => `${BASE_URL}tags/${tagId}`;
export const DELETE_TAG = (tagId) => `${BASE_URL}tags/${tagId}`;

export const POST = "post";
export const GET = "get";
export const PUT = "put";
export const DELETE = "delete";
